import { render, staticRenderFns } from "./DataSyncControl.vue?vue&type=template&id=48ebc9c8"
import script from "./DataSyncControl.vue?vue&type=script&lang=js"
export * from "./DataSyncControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports